var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"textF"},[_vm._v(_vm._s(_vm.Text))]),_c('div',{staticClass:"valueF"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }